export const s3Upload = async ({
    file,
    presignedUrl,
    mimeType
}: {
    file: File,
    presignedUrl: string,
    mimeType: string
}) => {
    const response = await fetch(presignedUrl, {
        method: 'PUT',
        body: file,
        headers: {
            'Content-Type': mimeType
        }
    });
    if (!response.ok) {
        const error = await response.text();
        throw new Error(`Failed to upload file to S3: ${error}`);
    }
};
